import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import anime from "animejs";

function VariationsTypeTooltip() {
  const [productModal] = useEnvValue('productModal')
  const [tooltipLabel] = useEnvValue('strings.chooseTypeTooltipLabel', 'Vælg')
  const [icons] = useEnvValue('icons')

  const handleOnClick = function (event) {
    event.preventDefault()
    const modal = document.querySelector('#product-modal')

    if (!modal) {
      return
    }

    anime({
      targets: modal.children[0],
      opacity: [0, 1],
      translateY: [-30, 0],
      duration: 300,
      easing: 'easeOutCubic',
      delay: 200
    })

    document.body.classList.add('modal-open')
    modal.classList.add('active')
  }

  return (
    <>
      {
        productModal.showModal === true && (
          <>
            <div className="mtt-variations__title mtt-variations__title--button" onClick={handleOnClick}>
              {tooltipLabel}
              <img src={icons.help} alt='tooltip icon'/>
            </div>
          </>
        )
      }
    </>
  )
}

export default VariationsTypeTooltip